import React, { useState, useEffect } from "react";
import '../styles/components/imageCard.css';

function ImageCard({ img, title, isMobile }) {

    const content = [
        [
            "production",
            ["<label class='bold size-23 test'><label class='orange-color'>3</label> mixers</label>", "— Capacity from 20 kilos to 1 ton/day —"],
            ["<label class='bold size-23'><label class='orange-color'>6</label> capsule fillers</label>", " — Capacity of 200,000 capsules/hour —"],
            ["<label class='bold size-23'><label class='orange-color'>6</label> capsule polishers</label>"],
            ["<label class='bold size-23'><label class='orange-color'>1</label> liquid filler</label>", "— From 10 to 150 ml —"]
        ],
        [
            "packaging",
            ["<label class='bold size-23'><label class='orange-color'>1</label> pill bottle filling line</label>", "with capping and labelling for glass and plastic bottle", "— Capacity of 10,000 units/day —"],
            ["<label class='bold size-23'><label class='orange-color'>2</label> automated blistering line</label>", "— Capacity of 60,000 units/day —"],
            ["<label class='bold size-23'><label class='orange-color'>2</label> automatic cartoning machines</label>"]
        ],
        [
            "quality",
            ["<label class='bold size-23'>Guaranteed quality control</label>", "— Several certifications —"],
            ["<label class='bold size-23'>ISO 22000 project</label>", "Since late 2022, we have taken the necessary steps to obtain the ISO 22000 certification."]
        ]
    ];

    // Recherche du contenu en fonction du titre
    const matchingContent = content.find(item => item[0].toLowerCase() === title.toLowerCase());

    return (
        <div
            className="imageCard_global-container"
        >
            <div
                className="imageCard_background hovered"
                style={{
                    backgroundImage: `url(${img})`,
                }}
            ></div>
            <div className="imageCard_overlay">
                    <div className="imageCard_hover-text">
                        <h3 className="imageCard_title">{title}</h3>
                        {matchingContent && (
                            <ul className="imageCard_content">
                                {matchingContent.slice(1).map((line, index) => (
                                    <li
                                        key={index}
                                        dangerouslySetInnerHTML={{
                                            __html: Array.isArray(line)
                                                ? line.join("<br />")
                                                : line,
                                        }}
                                    ></li>
                                ))}
                            </ul>
                        )}
                    </div>
            </div>
        </div>
    );
}

export default ImageCard;
